import { SET_PAGE_TITLE } from '~/constants/types/title'

export const setPageTitle = (title) => ({
  type: SET_PAGE_TITLE,
  payload: title,
})
